const HB_FILTER_ERROR = [
  'Please add the locale parameter to the browser',
  'postMessage 域名检查不通过',
];
export default HB_FILTER_ERROR;
